module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello"
  }, [_c('div', {
    staticClass: "a-title"
  }, [_vm._v("关于项目")]), _vm._v(" "), _c('p', [_vm._v("这是我这一个vue.js开源项目。这里使用了mint-ui，vue-router，和webstorage。这个项目的的数据交互我使用了HTML5的本地存储，这样即使你没有服务的情况也可以保存数据。当然你也可以进行更改和优化。如果你有好的意见和想法可以联系我。如果你感觉该项目对你有用请你点赞。感谢你的支持！")]), _vm._v(" "), _c('div', {
    staticClass: "a-title"
  }, [_vm._v("项目简介")]), _vm._v(" "), _c('p', [_vm._v("功能：该应用是一个简单的通信录管理的小应用。实现了通信录得基本增删改查。本应用的数据只做本地存储。")]), _vm._v(" "), _c('p', [_vm._v("开发日期：" + _vm._s(_vm.devDate))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.3.0@vue-loader/lib/template-compiler.js?id=data-v-6c3bab78!./~/.10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/Hello.vue
// module id = 29
// module chunks = 0